import { Reveal, SectionHeading } from "@/components/landing/Reveal";
import {
  Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

const FAQ = () => (
  <section id="faq" className="py-24 md:py-32" data-testid="faq-section">
    <div className="max-content mx-auto px-4 md:px-8 lg:px-12">
      <Reveal className="flex justify-center text-center">
        <SectionHeading
          eyebrow="FAQ"
          title="Solar Questions, Answered"
          subtitle="Everything homeowners and businesses commonly ask before going solar."
          className="mx-auto"
        />
      </Reveal>

      <Reveal delay={0.1} className="mt-12 max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="rounded-2xl border border-slate-100 bg-white px-5 shadow-soft data-[state=open]:bg-brand-grey/70"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-base font-bold text-brand-navy hover:no-underline py-5" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] leading-[1.8] text-slate-500 pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default FAQ;
